import React from 'react'

interface ISloganProps {
  slogan: string
}

const Slogan: React.FC<ISloganProps> = ({ slogan }) => {
  return (
    <h1 className='text-slogan 2xl:text-slogan-2xl font-jost font-semibold white-space-pre ' tabIndex={0}>
      <div className='headerText'
        dangerouslySetInnerHTML={{ __html: slogan }}
      />
    </h1>
  )
}

export default Slogan
